import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Componente global para garantir redirecionamento para rotas com slug
 * Funciona como um guard global que intercepta todas as rotas
 */
const GlobalSlugRedirect: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const currentPath = location.pathname;
    
    // Rotas que não precisam de redirecionamento
    const publicRoutes = ['/', '/login', '/download'];
    if (publicRoutes.includes(currentPath)) {
      return;
    }
    
    // Também permitir rotas com query params (ex: /download?app=123)
    if (currentPath.startsWith('/download')) {
      return;
    }

    // Permitir rotas da API passarem direto (não interceptar)
    if (currentPath.startsWith('/api/')) {
      return;
    }

    // Verificar se já tem slug
    const hasSlug = checkIfHasSlug(currentPath);
    
    if (!hasSlug) {
      // Não forçar slug padrão; deixar rota pública tratar (CmsSelector)
      return;
    }
  }, [location.pathname, navigate]);

  // Este componente não renderiza nada, apenas executa a lógica de redirecionamento
  return null;
};

/**
 * Verifica se a rota já tem um slug válido
 */
const checkIfHasSlug = (path: string): boolean => {
  const segments = path.split('/');
  const firstSegment = segments[1];
  
  // Se não tiver primeiro segmento, não tem slug
  if (!firstSegment || firstSegment === '') {
    return false;
  }
  
  // Lista de rotas que NÃO são slugs (rotas especiais)
  const nonSlugRoutes = ['login', 'download', 'api', 'static', 'assets', 'favicon.ico', 'manifest.json', 'robots.txt'];
  
  // Se a rota começa com /api/, não é um slug
  if (path.startsWith('/api/')) {
    return false;
  }
  
  // Se for uma rota especial, não tem slug
  if (nonSlugRoutes.includes(firstSegment)) {
    return false;
  }
  
  // Não realizar verificações específicas de slug padrão para evitar loops
  
  // Se chegou até aqui, tem slug
  return true;
};

export default GlobalSlugRedirect;
